<template>
	<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path fill-rule="evenodd" clip-rule="evenodd" d="M4.16667 2.5H14.1667L17.5 5.83333V15.8333C17.5 16.75 16.75 17.5 15.8333 17.5H4.16667C3.24167 17.5 2.5 16.75 2.5 15.8333V4.16667C2.5 3.25 3.24167 2.5 4.16667 2.5ZM4.16667 15.8333H15.8333V6.525L13.475 4.16667H4.16667V15.8333Z" :fill="fill_color" :fill-opacity="opacity"/>
		<path d="M5.83337 4.16666H12.5V5.66666C12.5 6.21894 12.0523 6.66666 11.5 6.66666H6.83337C6.28109 6.66666 5.83337 6.21894 5.83337 5.66666V4.16666Z" :fill="fill_color" :fill-opacity="opacity"/>
		<path d="M5.83337 10.1667C5.83337 9.61437 6.28109 9.16666 6.83337 9.16666H13.1667C13.719 9.16666 14.1667 9.61437 14.1667 10.1667V15H5.83337V10.1667Z" :fill="fill_color" :fill-opacity="opacity"/>
	</svg>
</template>

<script>
import base_icon from '@/components/icons/base_icon';

export default {
	extends: base_icon
}
</script>